export var createMuiDialogOverrides = function (_a) {
    var typography = _a.typography;
    return {
        styleOverrides: {
            paperWidthMd: {
                'max-width': typography.pxToRem(800),
            },
            paperWidthSm: {
                'max-width': typography.pxToRem(640),
            },
            paperWidthXs: {
                'max-width': typography.pxToRem(448),
            },
        },
    };
};
